import wireframePieChartMenuIcon from '../assets/icons/wireframePieChartMenuIcon.svg';
import WireframeImage from './WireframeImage';

class WireframePieChart extends WireframeImage {
  constructor(fabricObject) {
    fabricObject.style ||= 'pieChart';
    super(fabricObject);
  }

  static iconSvg() {
    return wireframePieChartMenuIcon;
  }

  static externalName(): string {
    return 'Pie chart';
  }
}

export default WireframePieChart;
